<template>
  <div class="page-register">
    <Navigation title="新用户注册" isListenClick @listenClick="handleClickBack()"></Navigation>
    <div class="content-wrap">
      <div class="input-item">
        <span class="label">手机号</span>
        <input placeholder="支持中国大陆手机" type="tel" v-model="mobile" maxlength="11" />
        <md-icon class="icon-option" name="clear" size="md" @click="mobile = ''" v-show="mobile.length > 0"></md-icon>
      </div>
      <div class="input-item">
        <span class="label">验证码</span>
        <input placeholder="6位数字" type="tel" v-model="smsCode" maxlength="6" />
        <count-down ref="countDown" class="count-down" :blueText="true" :totalTime="90" @clickBtn="handleClickSendSmsCode()"></count-down>
      </div>
      <div class="input-item">
        <span class="label">登录密码</span>
        <input placeholder="6-16位数字、字母或符号" :type="passwordType" v-model="password" maxlength="16" />
        <md-icon class="icon-option" name="clear" size="md" @click="password = ''" v-show="password.length > 0"></md-icon>
        <md-icon
          class="icon-option visibleIcon"
          v-show="passwordType === 'password'"
          name="visible"
          size="md"
          @click="passwordType = 'text'"
        ></md-icon>
        <md-icon
          class="icon-option visibleIcon"
          v-show="passwordType === 'text'"
          name="invisible"
          size="md"
          @click="passwordType = 'password'"
        ></md-icon>
      </div>
    </div>
    <div class="invite-wrap" v-if="inviteCode && inviteCodeStatus === 1">
      <span class="label">推广码</span>
      <span class="invite-code">{{ inviteCode }}</span>
      <div class="invite-info">
        <img class="avatar" v-if="prefixAvatar" :src="prefixAvatar" />
        <span class="nickname" v-if="prefixName">{{ prefixName }}</span>
      </div>
      <span class="btn-input-code rewrite" @click="handleClickInputInviteCode()">修改</span>
    </div>
    <!-- 邀请码无效 -->
    <div class="invite-wrap" v-if="inviteCodeStatus === 2">
      <span class="label">推广码</span>
      <span class="invite-code error">推广码{{ inviteCode }}无效</span>
      <span class="btn-input-code" @click="handleClickInputInviteCode()">重新填写</span>
    </div>
    <div class="btn-register" @click="handleClickSubmit()">
      <md-activity-indicator
        v-if="registerLoading"
        class="loading-indicator"
        type="carousel"
        :size="10"
        color="#fff"
        text-color="#fff"
      ></md-activity-indicator>
      <span v-show="!registerLoading">注册</span>
    </div>
    <md-agree class="agree-wrap" v-model="checkedAgree" size="md">
      我已同意<a :href="argumentUrl" class="agree-link">《董事惠用户协议》</a>
    </md-agree>
    <div class="login-wrap">
      <span class="tip">已有账号?</span>
      <span class="btn-login" @click="handleClickLogin()">立即登录</span>
    </div>
    <md-popup :mask-closable="false" v-model="showRegisterSuccessPopup">
      <div class="regSuccess-popup">
        <div class="reg-title">
          <span class="icon-wrap"><md-icon class="icon-success" name="success" size="lg"></md-icon></span><span class="p-title">注册成功</span>
        </div>
        <div class="reg-mobile">{{ this.mobile }}</div>
        <div class="reg-content">
          <div class="reg-item">
            <span class="name">推荐人:</span>
            <span class="text">{{ upperInfo.upperName }}</span>
          </div>
          <div class="reg-item">
            <span class="name">手　机:</span>
            <span class="text">{{ upperInfo.upperMobile }}</span>
            <span class="copy upperMobile" :data-clipboard-text="upperInfo.upperMobile">复制</span>
          </div>
          <div class="reg-item">
            <span class="name">微　信:</span>
            <span class="text">{{ upperInfo.upperWeixin }}</span>
            <span class="copy upperWeixin" :data-clipboard-text="upperInfo.upperWeixin">复制</span>
          </div>
        </div>
        <div class="btn-commit" :class="{ disable: inviteCode.length === 0 }" @click="handleClickAutoLogin()">确定</div>
      </div>
    </md-popup>
    <!-- 输入邀请码弹窗 -->
    <InputInviteCodePopup ref="inviteCodePopup" @next="handleClickNext"></InputInviteCodePopup>
  </div>
</template>

<script>
import Consts from '@/common/consts'
import Navigation from '@/components/navigation'
import InputInviteCodePopup from '@/components/inputInviteCodePopup'
import CountDown from '@/components/countDown'
import { Toast, ActivityIndicator, Agree, Icon, Popup } from 'mand-mobile'
import { getMd5, checkPhone } from '@/utils/help'
import Clipboard from 'clipboard'
import LoginService from '@/services/login'
export default {
  components: {
    Navigation,
    InputInviteCodePopup,
    CountDown,
    [Toast.name]: Toast,
    [ActivityIndicator.name]: ActivityIndicator,
    [Agree.name]: Agree,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
  },
  data() {
    return {
      argumentUrl: `https://static.${Consts.WAP_HOST}/agreement/user.html`,
      mobile: '', // 用户输入的手机号
      smsCode: '',
      password: '', // 用户输入的密码
      passwordType: 'password', // 密码的类型, 默认password,可见时是text类型
      prefixName: '', // 推荐人昵称
      prefixAvatar: '', // 推荐人头像
      inviteCode: '', // 推广码
      inviteCodeStatus: 0, // 推广码的状态 0:未校验 1:已校验,正确 2:已校验,无效
      checkedAgree: true, // 是否选中用户协议
      registerLoading: false,
      registerKey: '', // 注册所需的key
      showRegisterSuccessPopup: false, // 注册成功的弹窗
      upperInfo: {
        upperName: '',
        upperMobile: '',
        upperWeixin: '',
      },
    }
  },
  created() {
    this.inviteCode = this.$route.params.inviteCode || ''
    this.fetchInviteName()
  },
  mounted() {
    const clipboard1 = new Clipboard('.upperMobile')
    clipboard1.on('success', e => {
      Toast.info(`${e.text} 复制成功`, 1000)
      e.clearSelection()
    })
    const clipboard2 = new Clipboard('.upperWeixin')
    clipboard2.on('success', e => {
      Toast.info(`${e.text} 复制成功`, 1000)
      e.clearSelection()
    })
  },
  methods: {
    /**
     * 点击输入邀请码
     */
    handleClickInputInviteCode() {
      this.$refs.inviteCodePopup.inviteCode = ''
      this.$refs.inviteCodePopup.showInviteCodePopup = true
    },
    /**
     * 输入邀请码点击下一步
     */
    handleClickNext(inviteCode) {
      this.inviteCode = inviteCode
      this.$refs.inviteCodePopup.showInviteCodePopup = false
      this.fetchInviteName()
    },
    /**
     * 获取邀请人昵称
     */
    fetchInviteName() {
      this.$http.user
        .getUperUserInfo(this.inviteCode)
        .then(res => {
          this.inviteCodeStatus = 1
          this.prefixName = res.data.cnName
          this.prefixAvatar = res.data.avator
        })
        .catch(() => {
          this.inviteCodeStatus = 2
        })
    },

    /**
     * 点击发送短信验证码
     */
    handleClickSendSmsCode() {
      if (this.mobile.length === 0) {
        Toast.info('请输入手机号', 1000)
        return
      }
      if (!checkPhone(this.mobile)) {
        Toast.info('手机号格式不正确', 1000)
        return
      }
      this.$http.user.sendSmsCode(this.mobile, false).then(success => {
        this.$refs.countDown.start() // 子组件启动倒计时
        Toast.succeed('验证码发送成功', 1000)
      })
    },
    /**
     * 点击确定
     */
    handleClickSubmit() {
      if (this.mobile.length === 0) {
        Toast.info('请输入手机号', 1000)
        return
      }
      if (!checkPhone(this.mobile)) {
        Toast.info('手机号格式不正确', 1000)
        return
      }
      if (this.password.length === 0) {
        Toast.info('请输入密码', 1000)
        return
      }
      if (this.password.length < 6) {
        Toast.info('密码长度最少6位', 1000)
        return
      }
      if (this.smsCode.length < 6) {
        Toast.info('短信验证码长度为6位', 1000)
        return
      }
      if (!this.checkedAgree) {
        this.$toast('您还没同意用户协议')
        return
      }
      this.fetchRegisterKey()
    },
    /**
     * 获取注册所需的key
     */
    fetchRegisterKey() {
      if (this.registerLoading) {
        return
      }
      this.registerLoading = true
      if (this.registerKey) {
        this.register()
      } else {
        this.$http.user
          .loadUserRegisterKey()
          .then(res => {
            this.registerKey = res.data
            this.register()
          })
          .catch(() => {
            this.registerLoading = false
          })
      }
    },
    /**
     * 注册
     */
    register() {
      let pwd = getMd5(`${this.password}${this.registerKey}`)
      this.$http.user
        .userRegister({
          cnName: '',
          photo: '',
          mobile: this.mobile,
          smsCode: this.smsCode,
          registerKey: this.registerKey,
          password: pwd,
          unionid: '',
          prefix: this.inviteCode,
          code: '',
        })
        .then(res => {
          this.registerLoading = false
          if (res.code === 1) {
            this.upperInfo = res.data
            this.showRegisterSuccessPopup = true
          }
        })
        .catch(() => {
          this.registerLoading = false
        })
    },
    /**
     * 注册成功后点击自动登录
     */
    async handleClickAutoLogin() {
      this.showRegisterSuccessPopup = false
      let pwd = getMd5(`${this.password}${this.registerKey}`)
      await LoginService.accountLogin(this.mobile, pwd, true)
      this.$router.push({ name: 'home' })
    },
    /**
     * 点击返回
     */
    handleClickBack() {
      this.$router.go(-1)
    },
    /**
     * 立即登录
     */
    handleClickLogin() {
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
<style type="text/css" lang="scss" scoped>
.page-register {
  position: relative;
  height: 100%;
  background: #f5f5f5;
  color: #232321;
  .content-wrap {
    margin-top: 0.2rem;
    background: #fff;
    padding: 0 0.4rem;
    overflow: hidden;
    .input-item {
      position: relative;
      display: flex;
      align-items: center;
      height: 1rem;
      background: #fff;
      &:not(:last-child):after {
        position: absolute;
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        height: 0.02rem;
        background: #efefef;
        transform: scaleY(0.5);
      }
      .label {
        width: 1.3rem;
        font-size: 0.28rem;
        font-weight: 500;
      }
      input {
        flex: 1;
        height: 0.8rem;
        line-height: 0.4rem;
        padding: 0.2rem 0.3rem;
        background: #fff;
        font-size: 0.28rem;
        &::-webkit-input-placeholder {
          color: #aab2bd;
          font-size: 0.26rem;
        }
      }
      .icon-option {
        width: 0.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: center;
        color: #ddd;
        &.visibleIcon {
          color: #314659;
        }
        &:active {
          opacity: 0.3;
        }
      }
      .count-down {
        padding: 0.1rem;
        font-size: 0.24rem;
        border: 0.02rem solid #232321;
        border-radius: 0.04rem;
        color: #232321;
      }
    }
  }
  .invite-wrap {
    // 邀请人信息
    display: flex;
    align-items: center;
    height: 1rem;
    padding: 0 0.4rem;
    background: #fff;
    margin-top: 0.4rem;
    .label {
      width: 1.3rem;
      font-size: 0.28rem;
      font-weight: 500;
    }
    .invite-code {
      flex: 1;
      padding: 0 0.3rem;
      font-weight: 600;
      color: #aab2bd;
      &.error {
        font-weight: normal;
        color: #ff1a1a;
      }
    }
    .invite-info {
      display: flex;
      align-items: center;
      border: 0.02rem solid #fafafa;
      box-shadow: 0 0.06rem 0.06rem 0 rgba(0, 0, 0, 0.05);
      background: #fff;
      padding: 0.04rem 0.12rem;
      border-radius: 0.06rem;
      .avatar {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        vertical-align: middle;
      }
      .nickname {
        margin-left: 0.08rem;
        font-size: 0.24rem;
        font-weight: 300;
      }
    }
    .btn-input-code {
      margin-left: 0.12rem;
      display: inline-block;
      height: 0.6rem;
      line-height: 0.6rem;
      border-radius: 0.04rem;
      color: #fff;
      font-size: 0.24rem;
      background-image: linear-gradient(to left, #ff1a1a, #fd2b6b);
      padding: 0 0.2rem 0 0.1rem;
      &.rewrite {
        margin-left: 0.06rem;
        background: none;
        color: #6e82d7;
      }
      &:active {
        opacity: 0.3;
      }
    }
  }
  .btn-register {
    // 注册
    margin: 0.8rem 0.4rem 0;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to left, #ff1a1a, #fd2b6b);
    border-radius: 0.4rem;
    font-size: 0.3rem;
    &.disable,
    &:active {
      opacity: 0.3;
    }
    .loading-indicator {
      display: inline-block;
      margin-bottom: 0;
      .md-activity-indicator-svg {
        height: 0.15rem !important;
      }
    }
  }
  .agree-wrap {
    // 用户协议
    margin: 0.2rem 0.6rem 0;
    font-size: 0.24rem;
    color: #858b9c;
    .agree-link {
      position: relative;
      z-index: 1;
      cursor: pointer;
      color: #5878b4;
    }
  }
  .login-wrap {
    // 立即登录
    position: absolute;
    bottom: 0.6rem;
    left: 0;
    right: 0;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    font-size: 0.26rem;
    font-weight: 300;
    .tip {
      color: #c5cad5;
      display: inline-block;
      vertical-align: middle;
    }
    .btn-login {
      display: inline-block;
      vertical-align: middle;
      padding: 0 0.1rem;
      line-height: 0.4rem;
      &:active {
        opacity: 0.3;
      }
    }
  }
  .regSuccess-popup {
    // 输入邀请码弹窗
    position: relative;
    width: 100%;
    min-width: 5.6rem;
    padding: 0.5rem 0 0;
    background: #fff;
    border-radius: 0.06rem;
    text-align: center;
    font-size: 0.28rem;
    .reg-title {
      .icon-wrap {
        display: inline-block;
        background: #f3f4f5;
        width: 0.7rem;
        height: 0.7rem;
        line-height: 0.7rem;
        box-sizing: content-box;
        border-radius: 50%;
        .icon-success {
          color: #44b549;
          vertical-align: middle;
          font-size: 0.56rem;
        }
      }
      .p-title {
        color: #44b549;
        font-weight: bold;
        font-size: 0.3rem;
        margin-left: 0.1rem;
      }
    }

    .reg-mobile {
      color: #44b549;
      font-weight: bold;
      font-size: 0.3rem;
      margin-top: 0.2rem;
    }
    .reg-content {
      box-shadow: 0 0.02rem 0.1rem 0.05rem rgba(0, 0, 0, 0.05);
      width: 88%;
      margin: 0.4rem auto 0.5rem;
      padding: 0.3rem;
      font-size: 0.26rem;
      color: rgba(68, 70, 84, 0.6);
      .reg-item {
        display: flex;
        align-items: center;
        height: 0.56rem;
        .name {
          width: 0.9rem;
          text-align: right;
        }
        .text {
          font-weight: bold;
          margin-left: 0.1rem;
          color: #444654;
        }
        .copy {
          margin-left: 0.2rem;
          color: #444654;
          border: 0.02rem solid #444654;
          padding: 0 0.2rem;
          font-size: 0.22rem;
          line-height: 0.4rem;
          &:active {
            opacity: 0.3;
          }
        }
      }
    }
    .btn-commit {
      border-top: 1px solid #eee;
      height: 1rem;
      line-height: 1rem;
      text-align: center;
      border-bottom-left-radius: 0.06rem;
      border-bottom-right-radius: 0.06rem;
      font-size: 0.32rem;
      &:active {
        opacity: 0.3;
      }
    }
  }
}
</style>
